import { Box } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import React from 'react';
import boddVariables from '../../variables.module.scss';

const FilterBadge = ({ children, isActive }: { children: React.ReactNode; isActive: boolean }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            bgcolor: isActive ? boddVariables.grey600 : boddVariables.grey10,
            color: isActive ? boddVariables.white : boddVariables.grey600,
            borderRadius: '4px',
            px: 1.5,
            py: 1,
            transition: 'all 0.2s ease-in-out',
        }}
    >
        <FilterListIcon sx={{ fill: 'currentColor' }} />
        {children}
    </Box>
);

export default FilterBadge;
